<template>
  <app-content class="h-panel">
    <div class="h-panel-bar">
      <span class="h-panel-title">资产类别</span>
    </div>

    <div class="margin-right-left margin-top">
      <template>
        <input type="text" placeholder="请输入编码或名称" v-model="value"/>
        <Button icon="fa fa-search" class="ml-10px" color="primary" @click="loadList">查询</Button>
      </template>
      <Button class="pull-right" @click="showForm()" color="primary" icon="fa fa-plus">
        新增
      </Button>
    </div>
    <div class="h-panel-body">
      <Table ref="xTable" :loading="loading" :datas="typeData" stripe>
        <TableItem title="资产类别编码" prop="code" :width="100"/>
        <TableItem title="资产类别名称" prop="name"/>
        <TableItem title="折旧方法" prop="depreciationMethod" dict="depreciationMethods"/>
        <TableItem title="使用期限" prop="useMonth"/>
        <TableItem title="残值率">
          <template #default="{data}">
            {{ data.residualRate }} %
          </template>
        </TableItem>
        <TableItem title="固定资产科目" prop="costName"/>
        <TableItem title="累计折旧科目" prop="depreciationName"/>
        <TableItem title="备注" prop="remark"/>
        <TableItem title="操作" align="center" :width="200">
          <template #default="{data}">
            <div class="actions">
              <span @click="showForm(data)">编辑</span>
              <span @click="remove(data.id)">删除</span>
            </div>
          </template>
        </TableItem>
      </Table>
    </div>
  </app-content>
</template>

<script>
import AssetsTypeForm from "@/views/assets/AssetsTypeForm.vue";

export default {
  name: "AssetsType",
  data() {
    return {
      value: '',
      loading: false,
      dataList: []
    }
  },
  computed: {
    typeData() {
      return this.dataList.filter(val => val.type === this.tab)
    },
    nextCode() {
      let code = (this.typeData.length + 1) + "";
      return code.padStart(3, '0');
    }
  },
  methods: {
    loadList() {
      this.loading = true
      this.$api.assets.assetsType.list(this.value).then(({data}) => {
        this.dataList = data || [];
      }).finally(() => this.loading = false)
    },
    showForm(entity = null) {
      this.$Modal({
        title: "固定资产类别信息",
        hasDivider: true,
        closeOnMask: false,
        width: 800,
        component: {
          vue: AssetsTypeForm,
          datas: {entity, type: this.tab, nextCode: this.nextCode},
        },
        events: {
          close: (modal) => {
            modal.close();
          },
          success: (modal) => {
            this.loadList();
            modal.close();
          }
        }
      });
    },
    remove(id) {
      this.$Confirm("确认删除?").then(() => {
        this.loading = true;
        this.$api.assets.assetsType.delete(id).then(() => {
          this.loadList();
        }).finally(() => this.loading = false)
      })
    }
  },
  created() {
    this.loadList();
  }
}
</script>

<style lang="less" scoped>
/deep/ .h-table th:not(:last-child) div {
  border-right: 1px solid @gray1-color;
}
</style>
